import * as React from "react";
import type { SVGProps } from "react";
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 5a1 1 0 0 0 0 2zm13 2a1 1 0 1 0 0-2zM8 11a1 1 0 1 0 0 2zm13 2a1 1 0 1 0 0-2zM8 17a1 1 0 1 0 0 2zm13 2a1 1 0 1 0 0-2zM3 5a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zM3 11a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM3 17a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM8 7h13V5H8zm0 6h13v-2H8zm0 6h13v-2H8zM3 7h.01V5H3zm0 6h.01v-2H3zm0 6h.01v-2H3z"
    />
  </svg>
);
export default SvgList;
